import {Pipe, PipeTransform} from '@angular/core';
import {Store} from '@ngxs/store';
import {Account} from '../../models/accounts/account.model';
import {AccountsState} from '../../state/accounts.state';

@Pipe({
  standalone: false,
  name: 'debtor'
})
export class DebtorResolvePipe implements PipeTransform {
  private readonly debtors: Account[];

  constructor(private store: Store) {
    this.debtors = this.store.selectSnapshot(AccountsState.debtors);
  }

  transform(value: any): string {
    if (value === null || value === undefined || value === '' || this.debtors?.length === 0) {
      return 'Debtor not found!';
    }
    const creditor = this.debtors.find(c => c.id === value);
    return creditor ? creditor.name : 'Debtor not found!';
  }

}
